import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import { withAuthenticationControllerWrapper } from "../AuthenticationControllerWrapper";
import { UpdatePasswordValidation } from "../../../utils/helpers/helperMethods/FormValidation";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import InputController from "../../../components/atoms/InputController/General/TextField-input/InputController";
import BaseModal from "../../../components/molecules/modal/BaseModal";

const UpdatePassword = ({ ...hocProps }) => {
  const [inputValue, setInputValue] = React.useState({
    password: "",
    newPassword: "",
    confirmPassword: "",
  });
  const { password, newPassword, confirmPassword } = inputValue;
  const [inputErrorValue, setInputErrorValue] = React.useState({
    password: { error: true, message: "Add Your Current Password" },
    newPassword: { error: true, message: "Add Your New Password" },
    confirmPassword: { error: true, message: "Confirm Your New Password" },
  });
  const [clickSubmit, setClickSubmit] = React.useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    UpdatePasswordValidation(inputValue, inputErrorValue, setInputErrorValue);
  }, [inputValue]);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setClickSubmit(true);
    if (
      !(
        inputErrorValue.password.error ||
        inputErrorValue.newPassword.error ||
        inputErrorValue.confirmPassword.error
      )
    ) {
      hocProps.handleResetPassword(inputValue.password, inputValue.newPassword);
    }
  }

  const handleDisable = () => {
    return (
      inputErrorValue.password.error ||
      inputErrorValue.newPassword.error ||
      inputErrorValue.confirmPassword.error
    );
    // return false;
  };
  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />
      <Headline />
      <div className="box-container-medium">
        <form onSubmit={(e) => handleSubmit(e)}>
          <Row>
            <Col sm={6}>
              <div className="input-row">
                <div className="title-name">Email</div>
                <div className="title-details">
                  :&nbsp;&nbsp;{hocProps.loggedUser}
                </div>
              </div>
              <div className="input-row">
                <InputController
                  value={password}
                  name="password"
                  placeholder="Current password"
                  errors={inputErrorValue.password}
                  type={"password"}
                  onChange={(e) => handleChange(e)}
                  label="Current Password"
                  clickSubmit={clickSubmit}
                />
              </div>
              <div className="input-row">
                <InputController
                  value={newPassword}
                  name="newPassword"
                  placeholder="New password"
                  errors={inputErrorValue.newPassword}
                  type={"password"}
                  onChange={(e) => handleChange(e)}
                  label="New Password"
                  clickSubmit={clickSubmit}
                />
              </div>
              <div className="input-row">
                <InputController
                  value={confirmPassword}
                  name="confirmPassword"
                  placeholder="Confirm New password"
                  errors={inputErrorValue.confirmPassword}
                  type={"password"}
                  onChange={(e) => handleChange(e)}
                  label="Confirm New Password"
                  clickSubmit={clickSubmit}
                />
              </div>
            </Col>
            <Col sm={6}>
              <ul>
                <li>Use at least 8 characters Optionally </li>
                <li>Use upper and lower case characters</li>
                <li>Use 1 or more numbers</li>
                <li>Use special characters</li>
              </ul>
            </Col>
          </Row>
          <hr />
          <div className="button-section">
            <div className="btn-line">
              <button className="cancel-btn">Back</button>
            </div>
            <div className="btn-line">
              <button
                className="submit-btn"
                type={"submit"}
                disabled={handleDisable()}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      {hocProps.modalShow ? (
        <BaseModal
          onHide={hocProps.onHide}
          show={hocProps.modalShow}
          header={hocProps.updatePasswordModalData.header}
          bodyHeadline={hocProps.updatePasswordModalData.bodyHeadline}
          bodyContent={hocProps.updatePasswordModalData.bodyContent}
          submitButton={hocProps.updatePasswordModalData.submitButton}
          cancelButton={hocProps.updatePasswordModalData.cancelButton}
          submitButtonContent={
            hocProps.updatePasswordModalData.submitButtonContent
          }
          cancelButtonContent={
            hocProps.updatePasswordModalData.cancelButtonContent
          }
        />
      ) : null}
    </Container>
  );
};

export default withAuthenticationControllerWrapper(UpdatePassword);
